import * as React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import Sprite from '~components/Sprite'
import { displayPrice } from '~helpers/price'
import { loadSizeMap } from '~redux/shop'

class CartAccordionItem extends React.Component {
  componentDidMount () {
    this.props.dispatch(loadSizeMap())
  }

  nameParts () {
    const [styleCode, productName, colourName] = this.props.productName.split(' - ')

    return {
      styleCode,
      productName,
      colourName
    }
  }

  handleQuantityChange (item, quantity) {
    this.props.onChange(item.id, {
      quantity,
      product_id: item.product_id,
      variant_id: item.variant_id
    })
  }

  mappedSize (label, type) {
    if (type === 'brief') {
      const map = this.props.sizeMap[type].find(s => parseInt(s.gb) === parseInt(label))

      if (map) {
        return map[this.props.sizingMode] || label
      }

      return label
    }

    const isCup = /[a-z]/i.test(label)

    if (isCup) {
      const map = this.props.sizeMap[type].cups.find(s => {
        return s.gb.toLowerCase() === label.toLowerCase()
      })

      if (map) {
        return map[this.props.sizingMode] || label
      }

      return label
    }

    const map = this.props.sizeMap[type].bands.find(s => parseInt(s.gb) === parseInt(label))

    if (map) {
      return map[this.props.sizingMode] || label
    }

    return label
  }

  getSize (label) {
    if (label) {
      return label.replace(/\D/g, '')
    }

    return null
  }

  getCupSize (label) {
    if (label) {
      return label.replace(/[0-9]/g, '')
    }

    return null
  }

  render () {
    const { styleCode, productName, colourName } = this.nameParts()

    return (
      <>
        <div className="col-span-8 grid grid-cols-8 mt-4 bg-lightGrey border-coral border">
          <span className="p-3 md:p-4">
            {this.props.brandName}
          </span>

          <span className="p-3 md:p-4 col-span-2">
            {productName}
          </span>

          <span className="p-3 md:p-4">
            #
            {styleCode}
          </span>

          <span className="p-3 md:p-4">
            {colourName}
          </span>

          <span className="p-3 md:p-4 ">
            {this.props.items.reduce((carry, item) => carry + item.quantity, 0)}
          </span>

          <span className="p-3 md:p-4">
            {displayPrice(this.props.items.reduce((carry, item) => carry + item.extended_sale_price, 0), this.props.currencyCode)}
          </span>

          <span className="p-3 md:p-4">
            <button type="button" onClick={() => this.props.toggle()} aria-label="Collaspe" className="mx-auto block">
              <span className="icon block w-6 h-6" aria-hidden="true">
                <Sprite name={this.props.expand ? 'minus' : 'plus'} />
              </span>
            </button>
          </span>
        </div>

        {this.props.expand && (
        <>
          <div className="col-span-8 p-3 md:p-4 xl:p-6 mb-6 overflow-hidden border-coral border-b border-l border-r" aria-expanded={this.props.expand}>
            <div className="grid grid-cols-8 col-span-8 mb-3 items-center md:mb-4 xl:mb-6">
              <span className="px-3 md:px-4 col-span-2 font-bold">
                Sku Number
              </span>

              <span className="px-3 md:px-4 font-bold">
                Size
              </span>

              <span className="px-3 md:px-4 font-bold">
                Qty
              </span>

              <span className="px-3 md:px-4 font-bold">
                Unit price
              </span>

              <span className="px-3 md:px-4 col-span-2 font-bold">
                Total unit price
              </span>

              <span className="pl-3 md:pl-4 font-bold">
                &nbsp;
              </span>
            </div>

            {this.props.items && (
            <div className="border border-coral">
              {this.props.items.map((item, index) => {
                const size = item.options.find(o => o.name === 'Size').value
                const isBra = /\d+\s*[a-z]+/i.test(size)
                const type = isBra ? 'bra' : 'brief'
                const localisedSize = this.mappedSize(this.getSize(size), type)
                const cupSizeLabel = this.mappedSize(this.getCupSize(size).trim(), type)
                const localisedCupSize = cupSizeLabel ? cupSizeLabel.toUpperCase() : ''

                return (
                  <div
                    key={item.id}
                    className={classNames(
                      'grid col-span-8 grid-cols-8 items-center',
                      { 'bg-pink': index % 2 !== 0 }
                    )}
                  >
                    <span className="p-3 md:p-4 col-span-2">
                      {item.sku}
                    </span>

                    <span className="p-3 md:p-4">
                      {`${localisedSize} ${localisedCupSize}`}
                    </span>

                    <span className="p-3 md:p-4">
                      <input
                        type="number"
                        className={classNames('rounded w-14 h-10 lg:w-15 lg:h-12 text-charcoal appearance-none bg-spinner bg-2 bg-no-repeat bg-right-3 transition-shadow duration-150 ease-in-out outline-none bg-lightGrey p-2 lg:p-3')}
                        onChange={e => this.handleQuantityChange(item, e.target.value)}
                        value={item.quantity}
                        disabled={this.props.busy}
                      />
                    </span>

                    <span className="p-3 md:p-4">
                      {displayPrice(item.sale_price, this.props.currencyCode)}
                    </span>

                    <span className="p-3 md:p-4">
                      {displayPrice(item.extended_sale_price, this.props.currencyCode)}
                    </span>

                    <span className="p-3 md:p-4">
                      &nbsp;
                    </span>

                    <span className="p-3 md:p-4 ">
                      <button type="button" onClick={() => this.handleQuantityChange(item, 0)} className="w-3 h-3 lg:w-4 lg:h-4 block mx-auto" aria-label="Remove">
                        <span className="icon block" aria-hidden="true">
                          <Sprite name="cross" />
                        </span>
                      </button>
                    </span>
                  </div>
                )
              })}
            </div>
            )}
          </div>
        </>
        )}
      </>
    )
  }
}

CartAccordionItem.propTypes = {
  productName: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  busy: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  expand: PropTypes.bool,
  toggle: PropTypes.func,
  sizeMap: PropTypes.object,
  sizingMode: PropTypes.string,
  brandName: PropTypes.string,
  dispatch: PropTypes.func
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  sizeMap: state.shop.sizeMap,
  sizingMode: state.shop.sizingMode
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  loadSizeMap: () => { dispatch(loadSizeMap()) }
})

export default connect(mapStateToProps, mapDispatchToProps)(CartAccordionItem)
